import projects from './projects';

export default process.env.REACT_APP_PROJECT as projects;

export const isBilling = projects.BILLING === process.env.REACT_APP_PROJECT;

export const isSpecialBilling = projects.BILLING_SPECIAL === process.env.REACT_APP_PROJECT;

export const isKazan = projects.KAZAN === process.env.REACT_APP_PROJECT;
